module.exports = __webpack_public_path__ + "media/images/pc/staffs/mv_photographer-8d14a579877921aa063529d2e80bd2e6.webp";